import type {MarkersInfo} from '../stores/slices/markers'
import {buildCommentIndex} from './get-suggestion-details'
import {extractSuggestionFromMarkdown} from '@github-ui/diff-lines/extract-suggestion-content'
import type {SuggestionIdentifier} from '../stores/slices/suggestion-batch'

export type SuggestionChange = {
  threadId: string
  path: string
  suggestion: string[]
}

/**
 * Extracts suggestion changes from suggestion identifiers using the markers store
 */
export function getSuggestionsFromSuggestionIds(
  markers: MarkersInfo | undefined,
  suggestionIds: SuggestionIdentifier[],
): SuggestionChange[] {
  if (!markers || suggestionIds.length === 0) {
    return []
  }

  const commentIndex = buildCommentIndex(markers)

  const changes: SuggestionChange[] = []

  for (const suggestionId of suggestionIds) {
    const found = commentIndex.get(suggestionId.commentDatabaseId)

    if (!found) {
      continue
    }

    const {comment, path} = found

    const allSuggestions = extractSuggestionFromMarkdown(comment.body)

    if (!allSuggestions || suggestionId.suggestionIndex >= allSuggestions.length) {
      continue
    }

    changes.push({
      threadId: String(suggestionId.commentDatabaseId),
      path,
      suggestion: allSuggestions,
    })
  }

  return changes
}
